import cx from "classnames";
import styles from "./Hamburger.module.scss";

interface Props {
  isExpanded: boolean;
}

const Hamburger = ({ isExpanded }: Props) => {
  return (
    <div className={cx(styles.root, isExpanded && styles.isExpanded)}>
      <div className={styles.box}>
        <div className={styles.inner} />
      </div>
    </div>
  );
};

export default Hamburger;
